<template>
    <div class="page-content">
        <div class="page-body">
            <div class="page-left">
                <div class="body-item">
                    <div class="f-16 mb-10 fw-b">确认订单信息</div>
                    <el-form label-width="100px" label-position="right">
                        <el-form-item label="入住时间：">
                            <el-date-picker
                                v-model="time"
                                type="daterange"
                                unlink-panels
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="入住日期"
                                end-placeholder="退房日期">
                            </el-date-picker>
                            <span v-if="totalDay" class="ml-20">共 {{ totalDay }} 晚</span>
                        </el-form-item>
                        <el-form-item label="大人人数：" required>
                            <el-input-number v-model="form.num" :min="1" :max="paramsData.max_people"></el-input-number>
                            <span
                                class="ml-20">注：最多{{ paramsData.max_people }}人（超出{{ paramsData.people }}人后收取额外费用）</span>
                        </el-form-item>
                    </el-form>
                </div>

                <div class="body-item">
                    <div class="f-16 mb-10 fw-b">其他信息</div>
                    <el-form label-width="100px" label-position="right">
                        <el-form-item label="备注信息：">
                            <el-input v-model="form.remarks" placeholder="可选填留言备注信息，如：是否需要儿童座椅，对车辆清洁要求等"
                                      type="textarea"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="width: 100%;display: flex;justify-content: center;align-items: center">
                    <el-button v-if="paramsData.flash === 1" type="primary" class="mt-30 mb-20" @click="showPay">
                        确认订单，前往付款
                    </el-button>
                    <el-button v-else type="primary" class="mt-30 mb-20" @click="showPay">确认订单</el-button>
                </div>

            </div>
            <div class="page-right">
                <div class="page-right-item">
                    <div class="right-title">订单信息</div>
                    <div class="right-item-info"></div>
                    <div class="right-item-row">
                        <div class="item-row-label">基本费用</div>
                        <div class="item-row-text color-red">{{ basePrice|parseMoney }}</div>
                    </div>
                    <div v-if="extraPrice" class="right-item-row">
                        <div class="item-row-label">额外人员费用</div>
                        <div class="item-row-text color-red">
                            <span>{{ form.num - paramsData.people }}</span>
                            <span class="ml-4 mr-4">x</span>
                            <span class="mr-6">{{ paramsData.capitation|parseMoney }}</span>
                            {{ extraPrice|parseMoney }}
                        </div>
                    </div>
                    <div class="right-item-row">
                        <div class="item-row-label">清洁费</div>
                        <div class="item-row-text color-red">{{ paramsData.cleaning|parseMoney }}</div>
                    </div>
                    <div class="right-item-row">
                        <div class="item-row-label">在线押金</div>
                        <div class="item-row-text color-red">{{ paramsData.deposit|parseMoney }}</div>
                    </div>
                    <div class="right-item-row">
                        <div class="item-row-label">合计费用</div>
                        <div class="item-row-text f-20 color-red">{{ totalPrice|parseMoney }}</div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :visible.sync="showPayDialog"></el-dialog>
    </div>
</template>

<script>
import PayCar from "../components/PayCar";
import {mapState} from 'vuex'

export default {
    name: "shuttlePay",
    components: {PayCar},
    data() {
        return {
            loading: false,
            showPayDialog: false,
            numAry: Array.from({length: 15}, (item, index) => index + 1),
            time: [],
            form: {
                num: 1,
                house_id: '',
                check_in_time: '',
                check_out_time: '',
                remarks: '',
                type: 1,
                is_reception: 2,
                kids: 0
            },
            remark: '',
            orderNum: '',
            pickerOptions: {
                disabledDate(data) {
                    let now = new Date().getTime();
                    let time = new Date(data).getTime();
                    return now >= (time + 24*3600*1000)
                }
            }
        }
    },
    created() {
    },
    computed: {
        ...mapState(['paramsData']),
        totalDay() {
            if (this.time && this.time.length) {
                let start = new Date(this.time[0]).getTime();
                let end = new Date(this.time[1]).getTime();
                let day = (end - start) / (1000 * 3600 * 24);
                day <= 0 ? 0 : day
                return day
            }
        },
        // basePrice() {
        //     if (this.form.num <= this.paramsData.people) {
        //         return this.form.num * this.paramsData.price
        //     }
        //     return this.paramsData.people * this.paramsData.price
        // }, 
		basePrice() {
            return this.paramsData.price
        },
        extraPrice() {
            if (this.form.num > this.paramsData.people) {
                let num = this.form.num - this.paramsData.people;
                return num * this.paramsData.capitation
            }
            return 0
        },
        totalPrice() {
            let cleaning = this.paramsData.cleaning || 0;
            let deposit = this.paramsData.deposit || 0;
            let total = this.basePrice + this.extraPrice
            return total * this.totalDay + deposit + cleaning
        }
    },
    methods: {
        setDisabledDate(data) {
            console.log(data)
            return false
        },
        async showPay() {
            if (this.time.length <= 0) return this.$message.warning('请选择入住时间')
            this.form.house_id = this.paramsData.id;
            this.form.is_reception = this.paramsData.is_reception;
            this.form.check_in_time = this.time[0];
            this.form.check_out_time = this.time[1];
            let [e, data] = await this.$api.reserveRoomApi(this.form)
            if (e) {
                return this.$message.warning(e.data.error)
            }
            if (this.paramsData.flash === 2) {
                this.$alert('下单成功，等待房东确认！', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.$router.push({path: '/center/myOrder'})
                    }
                })
            } else {

            }
        }
    },
}
</script>

<style scoped lang="less">
.page-content {
    padding: 20px;
    box-sizing: border-box;

    .page-body {
        width: 1200px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin: auto;

        .page-left {
            width: 900px;
            margin-right: 20px;
            background-color: #ffffff;
            box-shadow: 3px 3px 6px #A6A6A6;

            .body-item {
                padding: 20px;
                box-sizing: border-box;
                border-bottom: 1px solid #e2e2e2;
                text-align: left;

                &:last-child {
                    border-bottom: none;
                }
            }
        }

        .page-right {
            flex: 1;

            .page-right-item {
                width: 100%;
                background-color: #ffffff;
                box-shadow: 3px 3px 6px #A6A6A6;
                margin-bottom: 20px;
                padding: 20px;
                box-sizing: border-box;

                .right-item-info {
                    text-align: right;
                    color: #949494;
                    margin-bottom: 10px;
                }

                .right-item-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 50px;
                    border-top: 1px solid #e2e2e2;
                    font-size: 14px;
                }

                .right-user {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    height: 60px;

                    &:hover {
                        .right-user-name {
                            color: #e44646;
                        }
                    }

                    .right-user-img {
                        width: 50px;
                        height: 50px;
                        border-radius: 100%;
                        object-fit: cover;
                    }

                    .right-user-name {
                        margin-left: 20px;
                        font-size: 18px;
                        font-weight: bold;

                    }
                }
            }
        }
    }
}
</style>

